import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useState } from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import classnames from "classnames";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./step-guide.css";
export function StepGuideItem(_ref) {
  var _classnames2;

  var value = _ref.value,
      numeral = _ref.numeral,
      visible = _ref.visible;
  return React.createElement("li", {
    className: classnames(styles.stepGuideItem, _defineProperty({}, styles.visible, visible))
  }, React.createElement("span", {
    className: classnames(styles.numeral, (_classnames2 = {}, _defineProperty(_classnames2, styles.one, numeral === 0), _defineProperty(_classnames2, styles.two, numeral === 1), _defineProperty(_classnames2, styles.three, numeral === 2), _classnames2))
  }), React.createElement("h4", {
    className: styles.title
  }, value.title), value.paragraphs.map(function (paragraph) {
    return React.createElement("p", {
      key: paragraph,
      className: styles.paragraph
    }, paragraph);
  }));
}

function StepGuide(_ref2) {
  var title = _ref2.title,
      items = _ref2.items,
      signUpUrl = _ref2.sign_up_url;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      currentIndex = _useState2[0],
      setCurrentIndex = _useState2[1];

  var last = items.length - 1;

  function next() {
    var nextIndex = currentIndex === last ? 0 : currentIndex + 1;
    setCurrentIndex(nextIndex);
  }

  function previous() {
    var previousIndex = currentIndex === 0 ? last : currentIndex - 1;
    setCurrentIndex(previousIndex);
  }

  return React.createElement("div", {
    className: styles.stepGuideWrapper
  }, title && React.createElement("h3", {
    className: styles.heading
  }, title), React.createElement("button", {
    "aria-label": gettext("paginated_carousel.prev_btn_txt") // previous
    ,
    type: "button",
    onClick: previous,
    className: styles.previous
  }, React.createElement(SVGIcon, {
    name: "chevron",
    rotate: -180
  })), React.createElement("button", {
    "aria-label": gettext("paginated_carousel.next_btn_txt") // next
    ,
    type: "button",
    onClick: next,
    className: styles.next
  }, React.createElement(SVGIcon, {
    name: "chevron"
  })), React.createElement("ol", {
    className: styles.stepGuideList
  }, items.map(function (value, index) {
    return React.createElement(StepGuideItem, {
      key: value.title,
      value: value,
      numeral: index,
      visible: index === currentIndex
    });
  })), React.createElement("a", {
    href: signUpUrl,
    className: styles.signUpLink
  }, gettext("homepage.module_value_props_sign_up_button") // Sign  up
  ));
}

export default StepGuide;